import { render, staticRenderFns } from "./NPS.vue?vue&type=template&id=55cd10bc&scoped=true&"
import script from "./NPS.vue?vue&type=script&lang=js&"
export * from "./NPS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cd10bc",
  null
  
)

export default component.exports